<template>
  <div>
    <el-input
      v-model="storeNum"
      placeholder="全部店铺"
      class="input-m m-r-6"
      :disabled="true"
      style="width: 240px"
    >
      <div slot="append">
        <el-link
          type="primary"
          style="margin-right: 10px"
          @click="storeVisible = true"
        >
          编辑
        </el-link>
        <el-link
          type="primary"
          @click="clearStore"
        >
          重置
        </el-link>
      </div>
    </el-input>

    <!-- 编辑门店对话框 -->
    <SpStoreSelect
      v-model="storeVisible"
      :select-data="selectStoreData"
      @chooseStore="chooseStore"
    />
  </div>
</template>

<script>
export default {
  name: 'SpSearchStore',
  data () {
    return {
      storeNum: null,
      storeVisible: false,
      selectStoreData: []
    }
  },
  methods: {
    //重置门店选择
    clearStore () {
      this.storeNum = ''
      this.selectStoreData = []
      this.$emit('chooseStore', [], [])
    },
    // 选择门店
    chooseStore (selectdata, storeids) {
      console.log(selectdata, 'selectdataselectdata', storeids)
      this.selectStoreData = selectdata
      let storeBns = []
      selectdata.forEach((v) => {
        storeBns = storeBns.concat(v.store_bn)
      })
      this.storeNum = '已选择' + selectdata.length + '家门店'
      this.storeVisible = false
      this.$emit('chooseStore', storeBns, storeids)
    }
  }
}
</script>

<style lang="scss" scoped></style>
